import { Link } from "react-router-dom";
import GraphUp from "../../assets/GraphUp";

export default function MoreInsightButton({
  moreInsights,
  customClass = "",
}: any) {
  const {
    path = "/dashboard/overview",
    redirect = false,
    onCLickHandle = () => {},
  } = moreInsights;
  return (
    <Link to={redirect && path} onClick={onCLickHandle}>
      <div
        className={`flex gap-2 items-center absolute bottom-[12px] ${customClass} `}
      >
        <GraphUp />
        <span className="text-[10px] text-hardGrey">view more insights</span>
      </div>
    </Link>
  );
}
